import { render, staticRenderFns } from "./TypeCheckBox.vue?vue&type=template&id=6bfb6cba&scoped=true"
import script from "./TypeCheckBox.vue?vue&type=script&lang=js"
export * from "./TypeCheckBox.vue?vue&type=script&lang=js"
import style0 from "./TypeCheckBox.vue?vue&type=style&index=0&id=6bfb6cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfb6cba",
  null
  
)

export default component.exports